<style scoped>
.technologyselected {
  border-style: solid;
  border-width: 0 0 0 0.5rem;
  border-color: #ffd300 !important;
}
.form-error {
  color: red;
  margin-left: 0;
  margin-top: -14px;
}
</style>
<template>
  <v-card style="text-align:left;padding:1rem;height:100%;overflow-y:scroll">
    <div>
      <v-card-title class="headline" style="margin-bottom:-1rem"
        ><v-icon>add</v-icon> New device</v-card-title
      >
      <div class="subheading" style="margin-left:2rem">
        Provision and register a new device within your user workspace.
      </div>
    </div>
    <v-card-text>
      <v-stepper v-model="e1">
        <v-stepper-header>
          <v-stepper-step
            step="1"
            editable
            color="purple"
            :complete="selectedTechnology ? true : false"
            v-on:click="e1 = 1"
            >Technology</v-stepper-step
          >

          <v-divider></v-divider>

          <v-stepper-step
            editable
            color="purple"
            :complete="e1 > 2"
            step="2"
            v-on:click="e1 = 2"
            >General</v-stepper-step
          >

          <v-divider></v-divider>

          <v-stepper-step step="3" color="purple">Provisioning</v-stepper-step>
        </v-stepper-header>

        <v-stepper-items>
          <v-stepper-content step="1">
            <v-card>
              <v-container v-bind="{[`grid-list-xs`]: true}" fluid>
                <v-layout row wrap>
                  <v-flex
                    v-for="(technology, index) in technologies"
                    :key="index"
                    xs12
                    sm12
                    md4
                    style="padding:1rem;max-height:20rem;"
                  >
                    <v-hover :disabled="technology[1].disabled">
                      <v-card
                        style="height:100%"
                        v-on:click="selectTechnology(technology[1])"
                        v-bind:class="{
                          technologyselected: selectedTechnology
                            ? selectedTechnology.id == technology[0]
                            : false,
                          'elevation-12': hover,
                          'elevation-2': !hover,
                        }"
                        slot-scope="{hover}"
                        flat
                        tile
                      >
                        <v-expand-transition v-if="technology[1].disabled">
                          <div
                            class="d-flex grey lighten-2 v-card--reveal title"
                            style="height: 100%;opacity:0.7;position:absolute;height:100%;width:100%;justify-content: center;padding:1rem"
                          >
                            <span> <v-icon>star</v-icon> Via mobile app</span>
                          </div>
                        </v-expand-transition>

                        <v-expand-transition v-if="technology[1].preview">
                          <div
                            class="d-flex grey lighten-2 v-card--reveal title"
                            style="opacity:0.4;position:absolute;height:100%;width:100%;justify-content: center;padding:1rem"
                          >
                            <span> <v-icon>star</v-icon> Preview</span>
                          </div>
                        </v-expand-transition>

                        <v-card-title
                          style="padding:0.5rem;height:5rem;"
                          align-content-left
                        >
                          <img
                            :src="
                              '/assets/technology/' +
                                technology[0].replaceAll(':', '_') +
                                '.png'
                            "
                            alt=""
                            style="width:8rem;padding:0.5rem;display: block;margin-left: auto;margin-right: 0"
                          />
                        </v-card-title>
                        <div style="margin-top:2rem;margin-bottom:-1rem">
                          <v-card-title
                            primary-title
                            class="headline"
                            style="margin-bottom:-2rem"
                            >{{ technology[1].label }}</v-card-title
                          >
                          <v-card-text style="text-align:left">
                            <p>{{ technology[1].hint }}</p>
                          </v-card-text>
                        </div>
                      </v-card>
                    </v-hover>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card>
          </v-stepper-content>

          <v-stepper-content step="2">
            <v-card v-if="selectedTechnology">
              <v-container>
                <v-layout row wrap>
                  <v-flex xs12>
                    <v-form>
                      <v-layout row wrap align-center>
                        <v-flex xs12 style="margin-bottom:2rem">
                          <div>
                            <p style="margin-bottom:0" class="body-2">
                              <v-icon small>memory</v-icon> Device ID
                            </p>
                            <p style="margin-bottom:0" class="caption">
                              {{ general.device_id.hint }}
                            </p>
                          </div>
                          <v-text-field
                            ref="device_id"
                            name="device_id"
                            :label="general.device_id.label"
                            v-validate="
                              'required|min:' +
                                general.device_id.min +
                                '|max:' +
                                general.device_id.max +
                                '|regex:' +
                                general.device_id.regExp
                            "
                            :counter="general.device_id.max"
                            required="true"
                            v-model="model.device_id"
                            :error="errors.first('device_id') != undefined"
                          >
                          </v-text-field>
                          <div
                            v-show="errors.first('device_id')"
                            class="form-error caption"
                            style="text-align:left"
                          >
                            {{ errors.first("device_id") }}
                          </div>
                        </v-flex>
                        <v-flex xs12 style="margin-bottom:2rem">
                          <div>
                            <p style="margin-bottom:0" class="body-2">
                              <v-icon small>assignment_ind</v-icon> Label
                            </p>
                            <p style="margin-bottom:0" class="caption">
                              {{ general.label.hint }}
                            </p>
                          </div>
                          <v-text-field
                            ref="label"
                            name="label"
                            :label="general.label.label"
                            v-validate="
                              'required|min:' +
                                general.device_id.min +
                                '|max:' +
                                general.label.max +
                                '|regex:' +
                                general.label.regExp
                            "
                            required="true"
                            :counter="general.label.max"
                            v-model="model.label"
                            :error="errors.first('label') != undefined"
                          >
                          </v-text-field>
                          <div
                            v-show="errors.first('label')"
                            class="form-error caption"
                            style="text-align:left"
                          >
                            {{ errors.first("label") }}
                          </div>
                        </v-flex>

                        <!-- <v-flex xs12 v-if="selectedTechnology.id==='polaris'">
                                                <div>
                                                    <p style="margin-bottom:0" class="body-2"><v-icon small>assignment_ind</v-icon> Certificate</p>
                                                    <p style="margin-bottom:0" class="caption">X509 Certificate linked to the device authenticated identinty</p>
                                                </div>
                                                <v-switch
                                                    v-model="polarisCertificate"
                                                    v-on:change="model.certificate=(polarisCertificate?model.certificate:undefined)"
                                                    :label="'Use device certificate'"
                                                    style="margin-bottom:-1rem  "
                                                >
                                                </v-switch>
                                                <v-textarea v-model="model.certificate" :disabled="!polarisCertificate" placeholder="PEM certificate..."></v-textarea>
                                            </v-flex> -->
                      </v-layout>
                    </v-form>
                  </v-flex>
                </v-layout>
                <v-btn
                  block
                  dark
                  v-on:click="validate().then((d) => (e1 = 3))"
                  :disabled="
                    errors.first('label') || errors.first('device_id')
                      ? true
                      : false
                  "
                  color="#39a9dc"
                >
                  Next
                </v-btn>
              </v-container>
              <!-- <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn block  depressed  v-on:click="e1=1"> Back </v-btn>
                            <v-btn block dark v-on:click="validate().then( d => e1=3 )" :disabled="errors.first('label')||errors.first('device_id')?true:false" color="#39a9dc"> Next </v-btn>
                        </v-card-actions> -->
            </v-card>
          </v-stepper-content>

          <v-stepper-content step="3">
            <v-card v-if="selectedTechnology">
              <v-container>
                <v-layout row wrap>
                  <v-form style="width:100%">
                    <v-flex
                      xs12
                      v-if="
                        selectedTechnology.id ===
                          iotservicessdk.shared.types.DeviceConnectivity
                            .LORA_TTN ||
                          selectedTechnology.id ===
                            iotservicessdk.shared.types.DeviceConnectivity
                              .POLATIS ||
                          selectedTechnology.id ===
                            iotservicessdk.shared.types.DeviceConnectivity
                              .ASTRA ||
                          selectedTechnology.id === 'steval-harvest1:mcu:demo:1'
                      "
                    >
                      <lora-form
                        v-on:submit="submit"
                        :model="model"
                        :deviceProfiles="deviceProfiles"
                      ></lora-form>
                    </v-flex>
                    <v-flex
                      xs12
                      v-else-if="
                        selectedTechnology.id ===
                          iotservicessdk.shared.types.DeviceConnectivity.LTE ||
                          selectedTechnology.id ===
                            iotservicessdk.shared.types.DeviceConnectivity
                              .WIFI ||
                          selectedTechnology.id ===
                            iotservicessdk.shared.types.DeviceConnectivity
                              .IOTDISCOVERYKIT ||
                          selectedTechnology.id ===
                            iotservicessdk.shared.types.DeviceConnectivity
                              .PCELL02FPATRLTE1 ||
                          selectedTechnology.id ===
                            'steval-harvest1:mcu:demo:1' ||
                          selectedTechnology.id === 'nbiot:mcu:demo:1'
                      "
                    >
                      <direct-connected-form
                        v-on:submit="submit"
                        :model="model"
                        :show-https="
                          selectedTechnology.id === 'nbiot:mcu:demo:1'
                        "
                        :show-existing-certificate="
                          selectedTechnology.id !== 'nbiot:mcu:demo:1'
                        "
                      ></direct-connected-form>
                    </v-flex>
                    <v-flex
                      xs12
                      v-else-if="
                        selectedTechnology.id ===
                          iotservicessdk.shared.types.DeviceConnectivity
                            .SIGFOX ||
                          selectedTechnology.id ===
                            iotservicessdk.shared.types.DeviceConnectivity
                              .NUCLEOFPATRSIGFOX1
                      "
                    >
                      <sigfox-form
                        v-on:submit="submit"
                        :apikeys="apikeys"
                        :deviceProfiles="deviceProfiles"
                        :model="model"
                      ></sigfox-form>
                    </v-flex>
                    <v-btn
                      block
                      dark
                      v-else
                      outline
                      style="float:left;width:100%;margin-left:0.5rem"
                      v-on:click="submit"
                      color="#39a9dc"
                    >
                      Submit
                    </v-btn>
                  </v-form>
                </v-layout>
              </v-container>
              <!-- <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn block depressed v-on:click="e1=2"> Back </v-btn>
                            <v-btn block dark v-on:click="next()" color="#39a9dc"> Submit </v-btn>
                        </v-card-actions> -->
            </v-card>
          </v-stepper-content>
          <!-- <v-btn block outline style="float:left;width:30%"> Back </v-btn>
                <v-btn block dark outline style="float:left;width:69%;margin-left:0.5rem" color="#39a9dc"> Next </v-btn> -->
        </v-stepper-items>
      </v-stepper>
    </v-card-text>
  </v-card>
</template>
<script>
import {mapState} from "vuex";
import LoraForm from "./LoraForm";
import SigfoxForm from "./SigfoxForm";
import DirectConnectedForm from "./DirectConnectedForm";
import * as iotservicessdk from "iot-services-sdk";

export default {
  components: {
    LoraForm,
    SigfoxForm,
    DirectConnectedForm,
  },

  data() {
    return {
      polarisCertificate: false,
      e1: 1,
      selectedTechnology: null,
      model: {
        device_id: null,
        label: null,
        technology: null,

        certificate: null,
        device_profile: null,
        lora: {},
        sigfox: null,
      },
    };
  },

  watch: {
    "model.device_id": async function() {
      if (this.general.device_id.upperCase) {
        if (this.model.device_id) {
          this.model.device_id = this.model.device_id.toUpperCase();
        }
      }
    },
  },

  computed: {
    ...mapState({
      newDevice: (state) => state.metadata.models.data.newDevice,
      deviceProfiles: (state) => state.deviceProfiles.deviceProfiles,
      apikeys: (state) => state.apiKeys.apiKeys,
    }),

    iotservicessdk() {
      return iotservicessdk;
    },

    technologies() {
      const technologies = this.newDevice.fields
        .find((f) => f.name == "technology")
        .values.filter((v) => !v.hide)
        .map((v) => {
          return [
            v.ref,
            {
              id: v.ref,
              label: v.text,
              hint: v.hint,
              disabled: v.disabled,
              preview: v.preview,
            },
          ];
        });
      return technologies;
    },

    general() {
      if (!this.selectedTechnology) return null;

      const deviceIdModel = this.newDevice.fields.find(
        (f) =>
          f.name ==
          "id--" + this.selectedTechnology.id.toLowerCase().replace("_", ""),
      );
      const labelModel = this.newDevice.fields.find((f) => f.name == "label");
      const general = {
        device_id: {
          label: deviceIdModel.label,
          hint: deviceIdModel.hint,
          regExp: deviceIdModel.regexp.value,
          upperCase: deviceIdModel.regexp.autoUpperCase,
          min: deviceIdModel.min,
          max: deviceIdModel.max,
        },
        label: {
          label: labelModel.label,
          hint: labelModel.hint,
          regExp: labelModel.regexp.value,
          min: labelModel.min,
          max: labelModel.max,
        },
      };
      return general;
    },
  },

  mounted() {},

  methods: {
    async validate() {
      return new Promise(
        async (resolve, reject) =>
          await this.$validator
            .validate()
            .then((valid) => (valid ? resolve() : reject())),
      );
    },

    async submit() {
      const data = await this.$store.dispatch(
        "devices/registerDevice",
        this.model,
      );
      await this.$store.dispatch("devices/fetchDevices");
      this.$emit("data", data);
      this.polarisCertificate = false;
    },

    selectTechnology(technology) {
      this.selectedTechnology = technology;
      this.model.technology = technology.id;
      setTimeout(() => (this.e1 = 2), 300);
    },
  },
};
</script>
